import { ApplicationRef, ComponentRef, Inject, Injectable, NgModuleRef, ViewContainerRef } from '@angular/core';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { MobileContentNavigationComponent } from '@finder/shared/components/mobile-content-navigation/mobile-content-navigation.component';
import { LocaleService } from '@finder/shared/services/locale-service/locale-service.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class ContentNavigationService {

    activeLink: any;
    viewContainerRef: ViewContainerRef;
    mobileComponentRef: ComponentRef<MobileContentNavigationComponent>;

    private linkChanged$ = new BehaviorSubject<string>(void 0);

    constructor(
        private windowRef: WindowRef,
        @Inject(ApplicationRef) private app,
        private localeService: LocaleService,
    ) {}

    init(links: any[], logo: any, cta: any, ariaLabel?: string) {
        this.initActiveLink(links);
        this.viewContainerRef = this.app.components[0].instance.rootComponents;
        this.createMobileComponent(links, logo, cta, ariaLabel);
    }

    observeActiveLinkChange() : Observable<string> {
        return this.linkChanged$.asObservable();
    }

    initActiveLink(links: any[]) {
        const locale = '/' + this.localeService.getLocale();
        const pathname = this.windowRef.nativeWindow.location.pathname;
        const pathnameWithoutLocale = pathname.startsWith(locale) ? pathname.replace(locale, '') : pathname;

        this.activeLink = links.find(link => pathnameWithoutLocale === link.href);

        this.linkChanged$.next(this.activeLink);
    }

    disconnect() {
        this.removeMobileComponent();
    }

    update(links, logo, cta, ariaLabel?: string) {
        this.mobileComponentRef.instance.links = links;
        this.mobileComponentRef.instance.logo = logo;
        this.mobileComponentRef.instance.cta = cta;
        this.mobileComponentRef.instance.activeLink = this.activeLink || /* istanbul ignore else */ links[0];
        this.mobileComponentRef.instance.ariaLabel = ariaLabel;
    }

    setActiveLink(link) {
        this.activeLink = link;
        this.mobileComponentRef.instance.activeLink = this.activeLink;

        this.linkChanged$.next(this.activeLink);
    }

    private createMobileComponent(links, logo, cta, ariaLabel?: string) {
        // Create mobile component and update
        this.mobileComponentRef = this.viewContainerRef.createComponent(MobileContentNavigationComponent);
        this.update(links, logo, cta, ariaLabel);
    }

    private removeMobileComponent() {
        if (this.mobileComponentRef) {
            this.mobileComponentRef.destroy();
        }
    }
}
